import { TFunction } from 'hooks/useI18n';
import { SwitcherProps } from '../shared/switcher/Switcher.types';
import AverageSalaryByRole from './AverageSalaryByRole';

export const AVERAGESALARYBYROLEANDEXPERIENCETABS = (
  t: TFunction
): SwitcherProps => ({
  label: t('mantechcar25.benefits.average-salary-role.experience'),
  tabsName: 'averageSalaryByRoleAndExperience',
  tabs: [
    {
      id: 'exp-2',
      label: '<2 ' + t('mantechcar25.benefits.average-salary-role.years'),
      content: <AverageSalaryByRole experience="0-2" />
    },
    {
      id: 'exp2-5',
      label: '2-5 ' + t('mantechcar25.benefits.average-salary-role.years'),
      content: <AverageSalaryByRole experience="2-5" />
    },
    {
      id: 'exp5-10',
      label: '5-10 ' + t('mantechcar25.benefits.average-salary-role.years'),
      content: <AverageSalaryByRole experience="5-10" />
    },
    {
      id: 'exp+10',
      label: '>10 ' + t('mantechcar25.benefits.average-salary-role.years'),
      content: <AverageSalaryByRole experience="10-" />,
      defaultChecked: true
    }
  ]
});
